import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import Countdown from '@/components/landing/countdown'
import CtaLink from '@/components/landing/cta-link'

import { campaign } from '@/constants/campaign'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            {/* The flyer, shown whole: full width on phones, capped by the screen height on larger screens so the button stays in view. */}
            <section
                id='event'
                aria-labelledby='event-title'
                className='relative isolate flex min-h-svh w-full flex-col items-center justify-center overflow-hidden bg-black pb-8 selection:bg-primary selection:text-primary-foreground sm:py-[2vh]'
            >
                {/* Blurred, darkened copy of the flyer filling the screen behind the sharp one. Decorative only. */}
                <img
                    src={campaign.flyer.src}
                    alt=''
                    aria-hidden='true'
                    className='pointer-events-none fixed inset-0 -z-10 size-full scale-110 object-cover blur-[25px] brightness-85 saturate-180'
                />
                <div
                    aria-hidden='true'
                    className='pointer-events-none fixed inset-0 -z-10 bg-[radial-gradient(ellipse_at_center,transparent_60%,rgba(0,0,0,0.45)_100%)]'
                />
                <h1 id='event-title' className='sr-only'>
                    {campaign.pageTitle}
                </h1>

                <img
                    src={campaign.flyer.src}
                    alt={campaign.flyer.alt}
                    width={campaign.flyer.width}
                    height={campaign.flyer.height}
                    fetchPriority='high'
                    className='block h-auto w-full max-w-full object-contain shadow-[0_20px_60px_rgba(0,0,0,0.7)] sm:w-auto sm:max-h-[68vh] sm:landscape:max-h-[85vh]'
                />

                {/* Below the flyer on upright screens. On landscape screens it sits in the space left of the centered flyer, as a compact 2x2 block. */}
                <Countdown
                    stacked
                    className='mt-6 max-w-[18rem] px-4 sm:mt-[2.5vh] sm:max-w-[30rem] sm:landscape:absolute sm:landscape:top-1/2 sm:landscape:left-0 sm:landscape:mt-0 sm:landscape:w-[calc((100vw-68vh)/2)] sm:landscape:max-w-none sm:landscape:-translate-y-1/2 sm:landscape:px-[3vw]'
                />

                <CtaLink
                    href={campaign.button.href}
                    className='mt-6 sm:mt-[2vh]'
                >
                    {campaign.button.label}
                </CtaLink>
            </section>
        </Layout>
    )
}

export default Home
